export const authrizedPermissions = {
    'view_assessments': 'view_assessments',
    'conduct_view_assessments': 'conduct_view_assessments',
};